import PropTypes from 'prop-types';
import React, {useEffect, useRef, useState} from "react";

function ShowMoreLineLimited({ delay, moreInfoInput, lines}) {
    const [isShowMore, setIsShowMore] = useState(false);
    const node = useRef(null);
    let setTimeoutConst = null;
    
    useEffect(() => {
        return () => {
            if (setTimeoutConst) {
                clearTimeout(setTimeoutConst);
            }
        };
    });
    
    const handleClick = (event) => {
        if (node.current) {
            setIsShowMore(true);
        }
    };
    const handleClick2 = (event) => {
        if (node.current) {
            setIsShowMore(false);
        }
    };
    
    return (
        <>
            {/* <div className="cart_agree_item_desc_more_info">
              
            </div> */}
              <h2 ref={node} className={!isShowMore?"cart_agree_item_desc":"cart_agree_item_desc"}>
                    {moreInfoInput}
                </h2>
        </>
    );
}

ShowMoreLineLimited.propTypes = {
    moreInfoInput: PropTypes.string.isRequired,
    lines: PropTypes.number.isRequired,
    delay: PropTypes.number,
    // classNames: PropTypes.string.isRequired,
};

ShowMoreLineLimited.defaultProps = {
    delay: 0
};

export default ShowMoreLineLimited;